export const IconCart = ({ size, color }) => (
  <div style={{ display: 'flex' }}>
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.85714 19C8.33053 19 8.71429 18.6162 8.71429 18.1428C8.71429 17.6695 8.33053 17.2857 7.85714 17.2857C7.38376 17.2857 7 17.6695 7 18.1428C7 18.6162 7.38376 19 7.85714 19Z"
        stroke={color !== '' ? color : `white`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2859 19C17.7592 19 18.143 18.6162 18.143 18.1428C18.143 17.6695 17.7592 17.2857 17.2859 17.2857C16.8125 17.2857 16.4287 17.6695 16.4287 18.1428C16.4287 18.6162 16.8125 19 17.2859 19Z"
        stroke={color !== '' ? color : `white`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 1H4.42857L6.72571 12.4771C6.88749 13.2916 7.60976 13.8731 8.44 13.8571H16.7714C17.6017 13.8731 18.3239 13.2916 18.4857 12.4771L19.8571 5.28571H5.28571"
        stroke={color !== '' ? color : `white`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.76514 5.85205L6.99989 13.1866C6.99989 13.1866 17.7999 13.8961 18.1427 13.1866C18.4856 12.4772 19.857 5.85205 19.857 5.85205H5.76514Z"
        fill={color !== '' ? color : `white`}
      />
    </svg>
  </div>
)
